import IconDashboard from 'cccisd-icons/meter';
import IconTraining from 'cccisd-icons/book2';
import IconSessions from 'cccisd-icons/calendar4';
import IconProgress from 'cccisd-icons/user-check';
import IconOutcomes from 'cccisd-icons/clipboard2';
import IconReports from 'cccisd-icons/stats-dots';
import IconResources from 'cccisd-icons/image2';
import IconManage from 'cccisd-icons/cog';

const dashboard = {
    url: '/product/:productHandle/dashboard',
    label: 'Dashboard',
    icon: IconDashboard,
    handle: 'dashboard',
};

const training = {
    url: '/product/:productHandle/training',
    label: 'Training',
    icon: IconTraining,
    handle: 'training',
};

const sessions = {
    url: '/product/:productHandle/sessionData',
    label: 'Sessions',
    icon: IconSessions,
    handle: 'sessions',
};

const progress = {
    url: '/product/:productHandle/progressData',
    label: 'Progress',
    icon: IconProgress,
    handle: 'progress',
};

const outcomes = {
    url: '/product/:productHandle/outcomesData',
    label: 'Outcomes',
    icon: IconOutcomes,
    handle: 'outcomes',
};

const reports = {
    url: '/product/:productHandle/reportCenter',
    label: 'Reports',
    icon: IconReports,
    handle: 'reports',
};

const resources = {
    url: '/product/:productHandle/resourceCenter',
    label: 'Resources',
    icon: IconResources,
    handle: 'resources',
};

const manage = {
    url: '/product/:productHandle/manage',
    label: 'Manage',
    icon: IconManage,
    handle: 'manage',
};

// not included by default - for Org Admin only
export const courseProgress = {
    url: '/product/:productHandle/courseProgress',
    label: 'Course Progress',
    icon: IconOutcomes,
    handle: 'courseProgress',
};

const navLinks = {
    dashboard,
    training,
    sessions,
    progress,
    outcomes,
    reports,
    resources,
    manage,
};

export default navLinks;
